<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Body_Text__And__Centre_Alignment"><span><img alt="" id="Interior_Page" src="Interior_Page.jpg" style=" max-width: 100%; max-height: 100%;"/></span></p>
<p class="P_Body_Text"> </p>
<p class="P_Body_Text"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?7fa61f17